import {NaviRequest} from "./NaviRequest";
import {NaviRequestError} from "./NaviRequestError";

export class NaviClient {

    static readonly DEFAULT_ERROR_MESSAGE: string = 'エラーが発生しました。恐れ入りますが時間を置いて再度アクセスしてください。';


    public static search(searchParams: object) {
        let req = NaviRequest.createSearch(searchParams);
        return this.fetch(req);
    }


    public static favorite(company_id: number, type: string) {
        let req = NaviRequest.createFavorite(company_id, type);
        return this.fetch(req);
    }

    public static browsingDelete(company_id: number) {
        let req = NaviRequest.createBrowsingDelete(company_id);
        return this.fetch(req);
    }

    public static searchDelete(search_id: number) {
        let req = NaviRequest.createSearchDelete(search_id);
        return this.fetch(req);
    }

    public static simulation(company_id: number, params: object) {
        let req = NaviRequest.createSimulation(company_id, params);
        return this.fetch(req);
    }

    public static simulationDelete(simulation_id: number) {
        let req = NaviRequest.createSimulationDelete(simulation_id);
        return this.fetch(req);
    }

    public static playVideo(id: number) {
        let req = NaviRequest.createPlayVideo(id);
        return this.fetch(req);
    }
    
    public static recruitLink(company_id: number,click_url: string){
        let req = NaviRequest.createRecruitLink(company_id,click_url);
        return this.fetch(req);
    }

    private static fetch(request: NaviRequest): Promise<Response> {
        // @ts-ignore
        navi.loading();
        return new Promise((resolve, reject) => {
            var res = null;
            fetch(request).then(responce => {
                res = responce;
                if (!responce.ok && responce.status != 400) {
                    throw new NaviRequestError(this.DEFAULT_ERROR_MESSAGE, responce);
                }
                return responce.json();
            })
                .then((json) => {
                    if (res.status == 400) {
                        throw new NaviRequestError(json.message || this.DEFAULT_ERROR_MESSAGE, res);
                    }
                    resolve(json);
                })
                .catch(error => {
                    alert(error.message);
                    reject(error);
                })
                .finally(() => {
                    // @ts-ignore
                    navi.loading(false);
                });
        });

    }


}